<div class="bg-img-container">
  <div class="container">
    <div class="form">
      <h2>{{ 'report.gas' | translate }} {{ 'report.title' | translate }}</h2>
      <mat-divider></mat-divider>

      <!-- Gas Report form -->
      <form
        name="form"
        (ngSubmit)="f.form.valid && ok()"
        #f="ngForm"
        novalidate
      >
        <!-- Select Month -->
        <div>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="{{ 'report.selectDate' | translate }}"
              [formControl]="date"
              [max]="max"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker
              startView="multi-year"
              disabled="false"
              (yearSelected)="chosenYearHandler($event)"
              (monthSelected)="chosenMonthHandler($event, picker)"
              panelClass="example-month-picker"
            >
            </mat-datepicker>
            <mat-error *ngIf="date.invalid">{{
              'report.invalidDate' | translate
            }}</mat-error>
          </mat-form-field>
        </div>

        <!-- Submit button to get report -->
        <div class="pull-right">
          <button
            class="button-primary"
            id="generate-excel-report"
            bciprimarybutton
          >
            {{ 'report.ok' | translate }}
          </button>
        </div>
      </form>
      <!-- form end -->
    </div>
  </div>
</div>
